import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  resource
} from "@angular/core";
import { lastValueFrom } from "rxjs";
import { TagBackend } from "src/app/backend/api/tag/tag.backend";
import { map } from "rxjs/operators";
import { TagLight } from "src/app/backend/models/tag/tag";
import { colorGetLumaByHex } from "src/app/support/colors";

@Component({
  selector: "snt-tag",
  templateUrl: "tag.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
  styles: `
    :host {
      ::ng-deep {
        .dx-tag-remove-button::before {
          color: unset;
        }
      }
    }
  `
})
export class TagComponent {
  id = input<string | undefined>();
  name = input<string | undefined>();
  icon = input<string | undefined, string | undefined>(undefined, {
    transform: (value: string | undefined) => {
      if (!value) {
        return undefined;
      }

      return value.replace("fa-light", "fa-solid");
    }
  });
  color = input<string | undefined>();
  classes = input<string | undefined>();
  textClasses = input<string | undefined>();
  flex = input<boolean>(false);
  image = input<string | undefined>();

  uppercase = input<boolean>(false);

  enableDxTagRemoveButton = input<boolean>(false);

  tag = resource<
    {
      label: string;
      color: string | undefined;
    },
    {
      id: string | undefined;
      name: string | undefined;
      color: string | undefined;
    }
  >({
    params: () => {
      return {
        id: this.id(),
        name: this.name(),
        color: this.color()
      };
    },
    loader: ({ params: { name, color, id } }) => {
      switch (true) {
        case !!name: {
          return Promise.resolve({
            label: name,
            color: color
          });
        }
        case !!id: {
          return lastValueFrom(
            this.tagBackend.loadLight(id).pipe(
              map((tag: TagLight) => {
                return {
                  label: tag.name,
                  color: tag.color
                };
              })
            )
          );
        }
        default: {
          return Promise.resolve({
            label: "-",
            color: undefined
          });
        }
      }
    }
  });

  defaultTextClasses = computed<string>(() => {
    const color = this.color();
    if (!color) {
      return "text-slate-50";
    }

    const luma = colorGetLumaByHex(color);

    switch (true) {
      case luma <= 180:
        return "text-slate-50";
      default:
        return "text-slate-900";
    }
  });

  private readonly tagBackend = inject(TagBackend);
}
